import isEmpty from 'lodash/isEmpty';

import { createPartnerConfig } from '../base/PartnerConfigFactory';

import Parameters from './Parameters';
import validate from './validate';

export const name = 'Serfimex';

const config = createPartnerConfig({
    ParametersComponent: Parameters,
    buildParametersConfig: {
        extendParameters: (baseParameters, values, parameters) => {
            const { blind_objects, hitch, is_percentage, terms } =
                baseParameters;
            const { dealer_fee } = parameters;

            return {
                blind_objects,
                dealer_fee,
                hitch,
                is_percentage,
                terms,
            };
        },
    },
    buildPayloadConfig: {
        extendPayload: (basePayload, values) => {
            const { api_key, disabled_credentials, secret_key } = values;

            const extended = {
                ...basePayload,
                type_proposal_template: values.type_proposal_template,
            };

            // Agregar API key si no está vacío
            if (!isEmpty(api_key)) {
                extended.api_key = api_key;
            }

            // Agregar secret key si no está vacío
            if (!isEmpty(secret_key)) {
                extended.secret_key = secret_key;
            }

            // Agregar disabled_credentials si existe
            if (disabled_credentials !== undefined) {
                extended.disabled_credentials = disabled_credentials;
            }

            return extended;
        },
    },
    buildPrepareValuesConfig: {
        extendPrepareValues: (baseValues, values) => ({
            ...baseValues,
            api_key: values.api_key || '',
            disabled_credentials: values.disabled_credentials || false,
            secret_key: values.secret_key || '',
            type_proposal_template: values.type_proposal_template || '',
        }),
    },
    customAlgorithms: [{ label: 'API Key', value: 'static_api_key' }],
    name,
    validationConfig: { schema: validate },
});

const originalGetInitialValues = config.getInitialValues;
config.getInitialValues = () => ({
    ...originalGetInitialValues(),
    type_proposal_template: 'template',
});

export default { ...config, name };
